import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { AccordionWithButton } from 'UIPackage/MainModule/components/AccordionWithButton';

import styles from './KnmListByPlanAccordionCell.module.scss';

export const KnmListByPlanAccordionCell = ({ value }: ITableRenderCell<IKnmRaw>) => {
  const getDefaultItemWithKnmListByPlanTableAccordion = (items?: string[]) =>
    items &&
    items.length > 0 && (
      <>
        <div className={styles.AccordionItem}>{items[0]}</div>
        {items.length > 1 && (
          <AccordionWithButton
            content={items
              .filter((item, index) => item && index > 0)
              .map((item, index) => (
                <div key={index} className={styles.AccordionItem}>
                  {item}
                </div>
              ))}
          />
        )}
      </>
    );
  const currentValue = Array.isArray(value) && value.length && typeof value[0] === 'string' && (value as string[]);

  return <>{currentValue ? getDefaultItemWithKnmListByPlanTableAccordion(currentValue) : ''}</>;
};
